/**
 * components/spinner.tsx — the design's `.t-spinner` (thin rotating ring).
 * Cross-platform via Animated (no CSS keyframes needed).
 */
import React, { useEffect, useRef } from 'react';
import { Animated, Easing, Platform } from 'react-native';
import { LightColors as C } from '../theme/theme';

export interface SpinnerProps {
  size?: number;
  color?: string;
  borderWidth?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 16, color = C.accent, borderWidth = 2 }) => {
  const spin = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.timing(spin, {
        toValue: 1,
        duration: 700,
        easing: Easing.linear,
        useNativeDriver: Platform.OS !== 'web',
      }),
    );
    loop.start();
    return () => loop.stop();
  }, [spin]);

  const rotate = spin.interpolate({ inputRange: [0, 1], outputRange: ['0deg', '360deg'] });

  return (
    <Animated.View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        borderWidth,
        borderColor: C.line,
        borderTopColor: color,
        transform: [{ rotate }],
      }}
    />
  );
};

export default Spinner;
